import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ overline, title, description, align = "left" }) => (
    <Reveal className={align === "center" ? "text-center" : ""}>
        <motion.span
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="block h-px w-12 bg-sf-green origin-left mb-5"
        />
        <p className="sf-overline" data-testid={`overline-${overline.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            {overline}
        </p>
        <h2 className="font-display font-800 font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-white mt-5 max-w-3xl">
            {title}
        </h2>
        {description && (
            <p className="text-sf-silver text-base md:text-lg leading-relaxed mt-6 max-w-2xl">{description}</p>
        )}
    </Reveal>
);
